// extracted by mini-css-extract-plugin
module.exports = {"root":"FileDropZone_root__zZHj2","inner":"FileDropZone_inner__AuEGK","highlight":"FileDropZone_highlight__IInsN"};